module.exports = __webpack_public_path__ + "static/media/TightKnitLogoBrown.967211a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/TightKnitLogoBrown.svg
// module id = 332
// module chunks = 0